import { Routes as BrowserRoutes, Route } from "react-router-dom";
import LoginScreen from "../pages/LoginScreen";
import AuthGuard from "./AuthGuard";
// import Dashboard from "../pages/Dashboard/Dashboard";
import Messages from "../pages/Messages";
import Parks from "../pages/Parks/Parks";
import Customers from "../pages/Customers/Customers";
import Wallet from "../pages/Wallet/Wallet";
import ParkManagers from "../pages/ParkManagers/ParkManagers";
import Affliates from "../pages/Affliates/Affliates";
import Travels from "../pages/Travels";
import Settings from "../pages/Settings/Settings";
import CreateAd from "../pages/CreateAd";
import Promo from "../pages/Promo";
import Analytics from "../pages/Analytics/Analytics";
import Tracks from "../pages/Track/Tracks";
import AvailableRoutes from "../pages/AvailableRoutes";
import SignUp from "../pages/Signup";
import CreatePark from "pages/Parks/CreatePark";
import CreateParkManager from "pages/ParkManagers/CreateParkManager";
import TravelRegister from "../pages/TravelRegister";
import OrderDetails from "../pages/OrderDetails";
import Events from "../pages/Events";
import Orders from "../pages/Order/Orders(Trip)";
import CreateCustomers from "pages/Customers/CreateCustomers";
import Transactions from "pages/Transactions/Transactions";
import BookingOrderDetails from "pages/Bookings/OrderDetails";
import Users from "pages/Users/Users";
import UsersSub from "pages/Users/Users(Sub)";
import CustomersSub from "pages/Customers/Customer(Sub)";
import ParkManagerSub from "pages/ParkManagers/ParkManager(Sub)";
import AffliatesSub from "pages/Affliates/Affliiates(Sub)";
import AssignDriver from "pages/Bookings/AssignDriver";
import AssignDriverPot from "pages/Bookings/AssignDriverPot";
import PriceEstimator from "pages/Bookings/PriceEstimator";
// import BookingFlight from "pages/Bookings/Booking(Flight)";
import BookingRide from "pages/Bookings/Booking(Ride)";
import AirlineDetails from "pages/Bookings/AirlineDetails";
import SendMailComponent from "pages/SendEmail";
import SearchPNRComponent from "pages/SearchPNR";
import AddVehicle from "pages/vehicles/AddVehicle";
import States from "pages/states/States";
import Addons from "pages/Addons";
import AffiliateMarketing from "pages/AffiliateMarketing";
import AffiliateUserDetails from "pages/AffiliateMarketing/UserDetails";
import GuestGuard from "shared/GuestGuard";
import AnalyticsPage from "pages/AnalyticsPage/Analytics";
import ManualBookings from "pages/ManualBookings/ManualBookings";
import AddManualBooking from "pages/ManualBookings/AddManualBooking";
import TransactionCreationPage from "pages/Transactions/TransactionCreationPage";
import PopularDestinations from "pages/PopularDestinations/PopularDestinations";
import Airports from "pages/Airports/Airports";
import HotelBookings from "pages/Hotel/HotelBookings";
import Finance from "pages/Finance/Finance";

interface RouteConfig {
  path: string;
  element: JSX.Element;
  hasAuth?: boolean;
}
const ROUTES: RouteConfig[] = [
  {
    path: "/",
    element: <LoginScreen />,
  },
  {
    path: "/sign-up",
    element: <SignUp />,
    hasAuth: true,
  },
  {
    path: "/dashboard",
    element: <AnalyticsPage />,
    hasAuth: true,
  },
  {
    path: "/dashboard/manual-bookings",
    element: <ManualBookings />,
    hasAuth: true,
  },
  {
    path: "/dashboard/manual-bookings/add",
    element: <AddManualBooking />,
    hasAuth: true,
  },
  {
    path: "/dashboard/finance",
    element: <Finance />,
    hasAuth: true,
  },
  {
    path: "/dashboard/popular-destinations",
    element: <PopularDestinations />,
    hasAuth: true,
  },
  {
    path: "/dashboard/airports",
    element: <Airports />,
    hasAuth: true,
  },
  {
    path: "/dashboard/transactions/create",
    element: <TransactionCreationPage />,
    hasAuth: true,
  },
  {
    path: "/dashboard/send-mail",
    element: <SendMailComponent />,
    hasAuth: true,
  },
  {
    path: "/dashboard/searchpnr",
    element: <SearchPNRComponent />,
    hasAuth: true,
  },

  {
    path: "/wallet",
    element: <Wallet />,
    hasAuth: true,
  },
  {
    path: "/customers",
    element: <Customers />,
    hasAuth: true,
  },
  {
    path: "/customers/sub/",
    element: <CustomersSub />,
    hasAuth: true,
  },
  {
    path: "/customers/sub/insights",
    element: <CustomersSub />,
    hasAuth: true,
  },
  {
    path: "/customers/sub/medical-info",
    element: <CustomersSub />,
    hasAuth: true,
  },
  {
    path: "/customers/sub/travels",
    element: <CustomersSub />,
    hasAuth: true,
  },
  {
    path: "/customers/sub/transactions",
    element: <CustomersSub />,
    hasAuth: true,
  },
  {
    path: "/create-customers",
    element: <CreateCustomers />,
    hasAuth: true,
  },
  {
    path: "/park-managers",
    element: <ParkManagers />,
    hasAuth: true,
  },
  {
    path: "/park-managers/sub/events",
    element: <ParkManagerSub />,
    hasAuth: true,
  },
  {
    path: "/park-managers/sub/",
    element: <ParkManagerSub />,
    hasAuth: true,
  },
  {
    path: "/park-managers/sub/insight",
    element: <ParkManagerSub />,
    hasAuth: true,
  },
  {
    path: "/park-managers/sub/orders",
    element: <ParkManagerSub />,
    hasAuth: true,
  },
  {
    path: "/park-managers/sub/park-assigned",
    element: <ParkManagerSub />,
    hasAuth: true,
  },
  {
    path: "/park-managers/sub/transactions",
    element: <ParkManagerSub />,
    hasAuth: true,
  },
  {
    path: "/park-managers/sub/travels",
    element: <ParkManagerSub />,
    hasAuth: true,
  },
  {
    path: "/affliates",
    element: <Affliates />,
    hasAuth: true,
  },
  {
    path: "/affliates/sub/",
    element: <AffliatesSub />,
    hasAuth: true,
  },
  {
    path: "/affliates/sub/insights",
    element: <AffliatesSub />,
    hasAuth: true,
  },
  {
    path: "/affliates/sub/transactions",
    element: <AffliatesSub />,
    hasAuth: true,
  },
  {
    path: "/affliates/sub/orders",
    element: <AffliatesSub />,
    hasAuth: true,
  },
  {
    path: "/affliates/sub/referrals",
    element: <AffliatesSub />,
    hasAuth: true,
  },
  {
    path: "/parks",
    element: <Parks />,
    hasAuth: true,
  },
  {
    path: "/parks/information",
    element: <Parks />,
    hasAuth: true,
  },
  {
    path: "/parks/insights",
    element: <Parks />,
    hasAuth: true,
  },
  {
    path: "/parks/media",
    element: <Parks />,
    hasAuth: true,
  },
  {
    path: "/parks/park-manager",
    element: <Parks />,
    hasAuth: true,
  },
  {
    path: "/parks/transactions",
    element: <Parks />,
    hasAuth: true,
  },
  {
    path: "/parks/travels",
    element: <Parks />,
    hasAuth: true,
  },
  {
    path: "/messages",
    element: <Messages />,
    hasAuth: true,
  },

  {
    path: "/travels",
    element: <Travels />,
    hasAuth: true,
  },
  {
    path: "/travels/past-travels",
    element: <Travels />,
    hasAuth: true,
  },
  {
    path: "/travels/new-travels",
    element: <Travels />,
    hasAuth: true,
  },
  {
    path: "/travels/all-travels",
    element: <Travels />,
    hasAuth: true,
  },

  {
    path: "/promo",
    element: <Promo />,
    hasAuth: true,
  },
  {
    path: "/create-ad",
    element: <CreateAd />,
    hasAuth: true,
  },
  {
    path: "/settings",
    element: <Settings />,
    hasAuth: true,
  },
  {
    path: "/settings/profile",
    element: <Settings />,
    hasAuth: true,
  },
  {
    path: "/settings/sales",
    element: <Settings />,
    hasAuth: true,
  },
  {
    path: "/settings/expenses",
    element: <Settings />,
    hasAuth: true,
  },
  {
    path: "/settings/payout",
    element: <Settings />,
    hasAuth: true,
  },
  {
    path: "/settings/admin",
    element: <Settings />,
    hasAuth: true,
  },
  {
    path: "/routes",
    element: <AvailableRoutes />,
    hasAuth: true,
  },
  {
    path: "/users",
    element: <Users />,
    hasAuth: true,
  },
  {
    path: "/users/sub/",
    element: <UsersSub />,
    hasAuth: true,
  },
  {
    path: "/users/sub/insights",
    element: <UsersSub />,
    hasAuth: true,
  },
  {
    path: "/users/sub/travels",
    element: <UsersSub />,
    hasAuth: true,
  },
  {
    path: "/users/sub/transactions",
    element: <UsersSub />,
    hasAuth: true,
  },
  {
    path: "/bookings/flight",
    // element: <BookingFlight />,
    element: <AirlineDetails />,
    hasAuth: true,
  },
  {
    path: "/bookings/flight/:id",
    element: <AirlineDetails />,
    hasAuth: true,
  },
  {
    path: "/bookings/ride",
    element: <BookingRide />,
    hasAuth: true,
  },
  {
    path: "/bookings/hotel",
    element: <HotelBookings />,
    hasAuth: true,
  },
  {
    path: "/bookings/rideorderdetails",
    element: <BookingOrderDetails />,
    hasAuth: true,
  },
  {
    path: "/bookings/flightorderdetails/:id",
    element: <BookingOrderDetails />,
    hasAuth: true,
  },
  {
    path: "/bookings/assigndriver",
    element: <AssignDriver />,
    hasAuth: true,
  },
  {
    path: "/bookings/assigndriverinfo",
    element: <AssignDriverPot />,
    hasAuth: true,
  },
  {
    path: "/bookings/priceestimator",
    element: <PriceEstimator />,
    hasAuth: true,
  },
  {
    path: "/transactions",
    element: <Transactions />,
    hasAuth: true,
  },
  {
    path: "/travel-register",
    element: <TravelRegister />,
    hasAuth: true,
  },
  {
    path: "/travel-register/drivers-info",
    element: <TravelRegister />,
    hasAuth: true,
  },
  {
    path: "/travel-register/passengers",
    element: <TravelRegister />,
    hasAuth: true,
  },
  {
    path: "/track",
    element: <Tracks />,
    hasAuth: true,
  },
  {
    path: "/order-details",
    element: <OrderDetails />,
    hasAuth: true,
  },
  {
    path: "/analytics",
    element: <Analytics />,
    hasAuth: true,
  },
  {
    path: "/create-park",
    element: <CreatePark />,
    hasAuth: true,
  },
  {
    path: "/create-park-manager",
    element: <CreateParkManager />,
    hasAuth: true,
  },
  {
    path: "/events",
    element: <Events />,
    hasAuth: true,
  },

  {
    path: "/orders",
    element: <Orders />,
    hasAuth: true,
  },
  {
    path: "/states",
    element: <States />,
    hasAuth: true,
  },
  {
    path: "/addons",
    element: <Addons />,
    hasAuth: true,
  },
  {
    path: "/orders/new-orders",
    element: <Orders />,
    hasAuth: true,
  },
  {
    path: "/orders/all-orders",
    element: <Orders />,
    hasAuth: true,
  },
  {
    path: "/affiliate-marketing",
    element: <AffiliateMarketing />,
    hasAuth: true,
  },
  {
    path: "/home/analytics",
    element: <AnalyticsPage />,
    hasAuth: true,
  },
  {
    path: "/affiliate-marketing/user/:userId",
    element: <AffiliateUserDetails />,
    hasAuth: true,
  },
  {
    path: "/vehicles/add-vehicle",
    element: <AddVehicle />,
    hasAuth: true,
  },
  {
    path: "/orders/past-orders",
    element: <Orders />,
    hasAuth: true,
  },
  {
    path: "*",
    element: <h4>Not found</h4>,
    hasAuth: true,
  },
];

const AppRoute = () => {
  return (
    <>
      <BrowserRoutes>
        {ROUTES.map((route) => {
          const { hasAuth } = route;
          const Parent = hasAuth ? AuthGuard : GuestGuard;
          return (
            <Route
              key={route.path}
              path={route.path}
              element={<Parent>{route.element}</Parent>}
            />
          );
        })}
      </BrowserRoutes>
    </>
  );
};

export default AppRoute;
